<template>

  <rpm-card-list
    :title="title"
    :data="data"
    :loading="loading"
    :pagination="pagination"
    disabled-item-key="canceled"
    @change-page="$emit('change-page', $event)"
    :grid-class="`lg:grid-cols-${columns} grid-cols-1 gap-6`"
    disabled-card-classes="shadow-[inset_0px_0px_5px_1px_rgba(0,0,0,0.25)]"
    :cardLinkFunction="(item) => ({name: 'ServicesExecution', params: { service_id: item.serviceid }})"
  >
    <template #functions>
      <slot>
        <div class="text-end">
          <span @click="columns = 1" class="cursor-pointer"><i class="fa-solid fa-bars"></i></span>
          <span @click="columns = 2" class="pl-4 cursor-pointer"><i class="fa-solid fa-list"></i></span>
        </div>
      </slot>
    </template>

    <template #search>
      <section class="flex flex-row flex-wrap *:grow gap-x-6 gap-y-3 w-full">
        <rpm-input
          placeholder="Endereço, serviço, solicitante..."
          v-model="searchForm.term"
          label="Protocolo, solicitante..."
        ></rpm-input>


<!--        ajuste de inpuit-->
        <rpm-input
          type="select"
          placeholder="Serviço"
          v-model="searchForm.source_service"
          :loading="sourceServicesLoading"
          :options="sourceServices"
          optionLabel="name"
          optionValue="id"
          label="Serviço"
          @change="getSourceProceduresForMultipleExecution"
        ></rpm-input>

        <rpm-input
          type="select"
          placeholder="Procedimento"
          v-model="searchForm.source_procedure"
          :loading="sourceProceduresLoading"
          :options="sourceProcedures"
          optionLabel="name"
          optionValue="id"
          label="Procedimento"
        ></rpm-input>


        <rpm-input type="date" v-model="searchForm.started_at" label="Data Inícial"/>
        <rpm-input type="date" v-model="searchForm.finished_at" label="Data Final"/>

        <rpm-input
            type="select"
            placeholder="Secretaria"
            v-model="searchForm.organization_id"
            :options="$attrs.organizations"
            optionLabel="name"
            optionValue="id"
            label="Secretaria"
            v-if="$attrs.organizations"
        ></rpm-input>
        <rpm-input
            type="select"
            placeholder="Bairro"
            v-model="searchForm.neighborhood_id"
            :options="neighborhoods"
            optionLabel="neighborhood"
            optionValue="neighborhood_id"
            label="Bairro"
            v-if="neighborhoods"
        ></rpm-input>
      </section>
    </template>

    <template #badges="{ item }">
      <badge class="bg-theme" v-if="item.ticket">
        <span>
          <b>Protocolo: </b>
              <copy-span class="underline decoration-2 decoration-theme">
                {{ item.ticket.ticket_number }}
              </copy-span>
            </span>
      </badge>
      <badge class="bg-theme">
        <span>
              <copy-span class="underline decoration-2 decoration-theme">
                {{ item.serviceid }}
              </copy-span>
            </span>
      </badge>

      <badge text-size="text-xxs" :color="item.priority_color">{{ item.priority }}</badge>
      <badge
        text-size="text-xxs"
        :color="!item.servicestatuscolor ? '#344767':item.servicestatuscolor"
      >{{ item.servicestatusname }}</badge>
      <badge
        text-size="text-xxs"
        :color="item.service_origin.color"
      >{{ item.service_origin.name }}</badge>
    </template>

    <template #actions="{ item }">
      <rpm-button
        tooltip-text="executar"
        padding=""
        color="transparent"
        :to="{name: 'ServicesExecution', params: { service_id: item.serviceid }}"
        icon="fa-solid fa-square-up-right"
      ></rpm-button>
    </template>

    <template #info="{ item }">
      <div class="xl:grid xl:grid-cols-2 flex flex-col gap-3">
        <div class="flex flex-col">
          <router-link :to="{name: 'ServicesExecution', params: { service_id: item.serviceid }}">
            <span class="font-bold">{{ item.servicename }}</span>
          </router-link>

          <span class="text-sm"><b>Tipo:</b> {{ item.servicetype }}</span>
          <span class="text-sm"><b>Solicitante:</b> {{ item.personsname }}</span>
          <span class="text-sm"><b>Solicitado via:</b> {{ item.origin }}, dia {{ item.started_at }}</span>
          <span class="text-sm" v-if="item.address"><b>Endereço:</b> {{ item.address?.address }} - {{ item.address?.neighborhood }}, {{item.address?.number}}</span>
        </div>


        <div class="flex flex-col">
          <router-link :to="{name: 'ServicesExecution', params: { service_id: item.serviceid }}">
            <span class="font-bold">{{ item.procedurename }}</span>
          </router-link>
          <span class="text-sm"><b>Setor:</b> {{ item.current_organization ?? item.organization[0] }}</span>
          <span v-if="item.owner" class="text-sm"><b>Responsável:</b> {{ item.owner }}</span>
        </div>
      </div>
    </template>
  </rpm-card-list>

</template>

<script>

import serviceStatusRepository from "#repositories/serviceStatusRepository";
import sourceServicePriorityRepository from "#repositories/sourceServicePriorityRepository";

import RpmCardList from "#components/RpmCardList.vue";
import Badge from "#components/Badge.vue";
import addressRepository from "#repositories/addressRepository";
import {defaultLocation, defaultCity} from '#constants/appInfo'

import {request} from "#repositories/repository";
import serviceRepository from "#repositories/serviceRepository";
import sourceServiceRepository from "#repositories/sourceServiceRepository";
import sourceProcedureRepository from "#repositories/sourceProcedureRepository";

export default {
  name: "ServiceList",
  emits: ["change-page"],
  components: {
    RpmCardList,
    Badge
  },
  data() {
    return {
      service_status_id: '',
      protocol: '',
      term: '',
      openModal: false,
      selectedService: {},
      columns: 2,
      neighborhoods: [],
      //ajuste de input
      all: false,
      serviceList: [],
      serviceListLoading: false,
      proceduresIds: [],
      sourceServices: [],
      sourceServicesLoading: false,
      sourceProcedures: [],
      sourceProceduresLoading: false,
      procedure: undefined,
      procedureLoading: false,
    }
  },
  props: {
    data: {
      type: Array,
      default: []
    },
    searchForm: {
      type: Object,
      default: {}
    },
    pagination: {
      type: Object,
      default: {}
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    modalOpen(item) {
      this.openModal = true;
      this.selectedService = item;
    },
    async getNeighborhoods() {
      this.neighborhoodsLoading = true;
      this.neighborhoods = (
          await addressRepository.getNeighborhoods(7375)
      ).data;
      this.neighborhoodsLoading = false;
    },
    async getSourceServicesForMultipleExecution(){
      this.sourceServicesLoading = true;
      this.sourceServices = (
          await sourceServiceRepository.getSourceServicesForMultipleExecution()
      ).data;
      this.sourceServicesLoading = false;
    },
    async getSourceProceduresForMultipleExecution(){
      if(this.searchForm.source_service){
        this.sourceProceduresLoading = true;
        this.sourceProcedures = (
            await sourceProcedureRepository.getSourceProceduresForMultipleExecution(this.searchForm.source_service)
        ).data;
        this.sourceProceduresLoading = false;
      }
    },
    async getServicesForMultipleExecution(page){
      if(this.searchForm.source_procedure && this.searchForm.source_service){
        this.proceduresIds = [];
        this.serviceList = [];

        if (page && page !== 0) this.pagination.page = page;

        this.loading = true;

        this.serviceListLoading = true;

        this.serviceList = request.pagination(
            await serviceRepository.getServicesForMultipleExecution(this.searchForm, this.pagination),
            this.pagination
        );

        this.serviceListLoading = false;
      } else this.$notify('Selecione ao menos um tipo de serviço e um tipo de procedimento', 'warn');
    },
    async getSourceProcedureForMultipleExecution(){
      if(this.searchForm.source_procedure && this.searchForm.source_service && this.proceduresIds.length){
        this.procedureLoading = true;
        this.procedure = (
            await sourceProcedureRepository.getSourceProcedureForMultipleExecution(this.searchForm.source_procedure)
        ).data;
        this.procedureLoading = false;
      } else this.$notify('Selecione ao menos um tipo de serviço, um tipo de procedimento e um serviço', 'warn');
    },
  },

  watch: {
    all(value){
      this.proceduresIds = value ? this.serviceList.map(service => service.next_procedure_id):[];
    },
    'pagination.page'(){
      this.all = false;
    }
  },
  mounted() {
    this.getNeighborhoods();
    this.getSourceServicesForMultipleExecution();
  },

};

</script>
